import classNames from 'classnames'
import React from 'react'
import { Slide } from 'react-slideshow-image'
import 'react-slideshow-image/dist/styles.css'
import { WemoloTypography } from '../../../components/Wemolo'
import { MLPCase } from '../MLPContext'
import { CaseItem } from './CaseItem'
import { getPlateWithHighlightedChars } from '../utils/getPlateWithHighLightedChars'
import styles from './Carousel.module.css'

export const Carousel: React.FC<{
    mlpCase: MLPCase
}> = ({ mlpCase }) => {
    const [currentSlide, setCurrentSlide] = React.useState(0)

    const indicators =
        mlpCase.similar_detections.length > 1
            ? (index?: number) =>
                  index || index === 0 ? (
                      <div
                          className={classNames(styles.indicator, {
                              [styles.indicatorActive]: index === currentSlide
                          })}
                      >
                          <img
                              src={mlpCase.similar_detections[index]?.signed_url_lp}
                              alt="Event"
                              className={classNames(styles.indicatorImage, {
                                  [styles.indicatorImageActive]: index === currentSlide
                              })}
                          />
                          <WemoloTypography
                              variant={index === currentSlide ? 'body-large-emphasized' : 'body-medium'}
                              tag="span"
                          >
                              {getPlateWithHighlightedChars(
                                  mlpCase?.similar_detections?.[index]?.plate,
                                  mlpCase.offender.plate
                              )}
                          </WemoloTypography>
                      </div>
                  ) : (
                      <></>
                  )
            : false
    return (
        <Slide
            onStartChange={(_from, to) => {
                setCurrentSlide(to)
            }}
            arrows={mlpCase.similar_detections.length > 1}
            transitionDuration={300}
            indicators={mlpCase.similar_detections.length > 1 ? indicators : false}
            autoplay={false}
        >
            {mlpCase.similar_detections.map((detection, index) => (
                <div key={index} className={styles.slide}>
                    <CaseItem
                        height="30vh"
                        direction={detection.direction}
                        plate={detection.signed_url_lp}
                        timestamp={detection.timestamp}
                        deviceName={detection.device_id}
                        category={detection.category}
                        plateNumber={getPlateWithHighlightedChars(detection.plate, mlpCase.offender.plate)}
                        imageSrc={detection.signed_url_render}
                        lpness={detection.lpness}
                        lpr={detection.lpr}
                    />
                </div>
            ))}
        </Slide>
    )
}
